import { useMemo } from 'react';
import { useAppStore } from '@/stores/app-store';

/** Decode the Cognito groups claim from the stored access token. */
export function getCognitoGroups(token: string | null): string[] {
  if (!token) return [];
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    const groups = payload['cognito:groups'];
    return Array.isArray(groups) ? groups : [];
  } catch {
    return [];
  }
}

/** Whether the signed-in user is in the SuperAdmin Cognito group. */
export function useIsSuperAdmin(): boolean {
  const token = useAppStore((s) => s.token);
  return useMemo(() => getCognitoGroups(token).includes('SuperAdmin'), [token]);
}
